// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"643":"f4d89a5c","787":"53e6a0a1"}[chunkId] + ".chunk.js";
};